import { useState, useEffect, useMemo } from 'react';
import sortBy from 'lodash/sortBy';
import { useSelector } from 'react-redux';
import { RootState } from '../data/store';
import { TemplateMapping } from '../data/models/template';
import {
	fetchProjectConfigurations,
	fetchProjectSubTypes,
} from '../services/project-configuration.service';
import {
	ProjectConfiguration,
	ProjectSubType,
} from '../data/models/projectConfiguration';

const MAX_TEMPLATES = 999;

function useProjectSubTypesList(open: boolean) {
	const { astroToken } = useSelector((state: RootState) => state.authState);
	const [list, setList] = useState<ProjectSubType[]>([]);
	const [initialized, setInitialized] = useState<boolean>(false);

	useEffect(() => {
		const fetchConfigurationsForDropdown = async () => {
			const configurations = await fetchProjectSubTypes();
			/* 	searchText: '',
				order: 'name',
				direction: 'DESC',
				page: 0,
				take: MAX_TEMPLATES,
				// where: {},
			}); */
			setList(configurations);
			setInitialized(true);
		};
		if (astroToken && open) {
			fetchConfigurationsForDropdown();
		}
	}, [astroToken, open]);

	const dropdownOptions = useMemo(() => {
		return sortBy(
			list.map((subType: ProjectSubType) => ({
				id: subType.id,
				display: subType.display,
			})),
			['display']
		);
	}, [list]);

	const dropdownOptionsFullData = useMemo(() => {
		return sortBy(
			list.map((subType: ProjectSubType) => ({
				...subType,
				id: subType.id,
				display: subType.display,
			})),
			['display']
		);
	}, [list]);

	return {
		list,
		dropdownOptions,
		dropdownOptionsFullData,
		initialized,
	};
}

export default useProjectSubTypesList;
